"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var styled_components_1 = __importDefault(require("styled-components"));
var IndicatorBadge_1 = __importDefault(require("./IndicatorBadge"));
var test_attributes_1 = require("@carvana/test-attributes");
var Badge = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  border-radius: ", ";\n  padding: 0 ", " 0 7px;\n  border: ", ";\n"], ["\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  border-radius: ", ";\n  padding: 0 ", " 0 7px;\n  border: ", ";\n"])), helios_styles_1.borderRadius.lg, helios_styles_1.spacing.md, function (props) { return (props.outline ? "1px solid ".concat(helios_styles_1.border.weak) : 'none'); });
var BadgeText = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  margin-left: 7px;\n  color: ", ";\n  ", "\n"], ["\n  display: inline-block;\n  margin-left: 7px;\n  color: ", ";\n  ", "\n"])), function (props) { return (props.priority === 'disabled' ? helios_styles_1.text.disabled : helios_styles_1.text.default); }, helios_styles_1.label.sm);
var LabelBadge = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.priority, priority = _b === void 0 ? 'critical' : _b, _c = _a.outline, outline = _c === void 0 ? false : _c;
    var getTestAttributes = (0, test_attributes_1.useTestFunc)();
    return ((0, jsx_runtime_1.jsxs)(Badge, __assign({}, getTestAttributes('LabelBadge'), { className: className, outline: outline }, { children: [(0, jsx_runtime_1.jsx)(IndicatorBadge_1.default, { priority: priority, size: "md" }), (0, jsx_runtime_1.jsx)(BadgeText, __assign({ priority: priority }, { children: children }))] })));
};
exports.default = LabelBadge;
var templateObject_1, templateObject_2;
